import Vuex from "vuex";
import Vue from "vue";
import listItems from "./modules/listItems";

// Load Vuex
Vue.use(Vuex);

// Create store
export default new Vuex.Store({
	modules: {
		listItems,
	},
});
